import { render, staticRenderFns } from "./ShopOrderDetail.vue?vue&type=template&id=483e6299&scoped=true"
import script from "./ShopOrderDetail.vue?vue&type=script&lang=ts"
export * from "./ShopOrderDetail.vue?vue&type=script&lang=ts"
import style0 from "./ShopOrderDetail.vue?vue&type=style&index=0&id=483e6299&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483e6299",
  null
  
)

export default component.exports